var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('card',[_c('div',{staticClass:"card-bpdy"},[_c('h2',[_vm._v("Access to this page is restricted")]),_c('p',[_vm._v(" Please check with the site admin if you believe this is a mistake. ")])])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }